


























import { Prop, Component, Vue, Watch } from 'vue-property-decorator';
import CollapseCard from '@/components/layout/CollapseCard.vue';
import { FormItem, Input } from 'element-ui';
import {
  fetchQuotes_inquiries_quotes
} from '@/types/graphql/schemaTypes';

@Component({
  components: {
    CollapseCard,
    'el-form-item': FormItem,
    'el-input': Input
  }
})
export default class Additional extends Vue {
  @Prop({ required: true }) private quote!: fetchQuotes_inquiries_quotes;

  private margin = '';

  @Watch('quote.margin', { immediate: true })
  setInputs(margin: number) {
    this.margin = (margin * 100).toFixed(2) || '0';
  }

  @Watch('margin')
  emitInputs(margin: number) {
    this.$emit('update', parseFloat(this.margin) / 100);
  }
}
